import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { QRCategoryItemModel } from '@cue/api';

@Pipe({
  name: 'categoryIcon',
  standalone: true,
})
export class CategoryIconPipe implements PipeTransform {
  translocoService = inject(TranslocoService);

  transform(categoryId: string, categoryList: QRCategoryItemModel[]): string {
    return categoryList?.find((x) => x.qrCategoryId === categoryId)?.iconUrl;
  }
}
